enum HorizontalAlignmentDirections {
  Left = 'left',
  Right = 'right',
  Center = 'center'
}

export default HorizontalAlignmentDirections;
